import { render, staticRenderFns } from "./ActualizarSubSeccionModal.vue?vue&type=template&id=73877c98"
import script from "./ActualizarSubSeccionModal.vue?vue&type=script&lang=js"
export * from "./ActualizarSubSeccionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports